import { StyledWrapper } from './style';
import Button from '../../../../components/Button';

interface InsertToEsmaToastProps {
  t: (key: string) => string;
  reportingMemberState: string;
  onSave: () => void;
  onDiscard: () => void;
  isLoading: boolean;
}

export function InsertToEsmaToast({
  t,
  reportingMemberState,
  onSave,
  onDiscard,
  isLoading
}: InsertToEsmaToastProps) {
  return (
    <StyledWrapper id="insert-to-esma-toast">
      <p className="title" id="insert-to-esma-toast-title">
        Insert entries into {reportingMemberState === 'uk' ? 'ESMA' : 'FCA'} report
      </p>
      <p className="text" id="insert-to-esma-toast-text">
        Сhanges to the {reportingMemberState === 'uk' ? 'FCA' : 'ESMA'} static report will be
        inserted to the {reportingMemberState === 'uk' ? 'ESMA' : 'FCA'}
        <br /> report. Are you sure you want to proceed?
      </p>
      <div className="footer" id="insert-to-esma-toast-footer">
        <div id="insert-to-esma-toast-footer-spacer" />
        <div className="buttons" id="insert-to-esma-toast-buttons">
          <Button
            id="insert-to-esma-toast-discard-button"
            size="sm"
            onClick={onDiscard}
            variant="outlined"
          >
            Discard
          </Button>
          <Button
            id="insert-to-esma-toast-confirm-button"
            isLoading={isLoading}
            onClick={onSave}
            size="sm"
          >
            Yes, Insert
          </Button>
        </div>
      </div>
    </StyledWrapper>
  );
}
